import { useState } from "preact/hooks";
import { sb } from "../lib/supabase";
import { prefs, setPref, type Accent } from "../lib/prefs";

/** Lets a signed-in user set or change their password (optional second way to sign in). */
export function PasswordCard() {
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<{ ok: boolean; text: string } | null>(null);
  return (
    <section class="card">
      <header><h2>Sign-in password</h2></header>
      <p class="muted small">Optional. Lets you sign in with email + password instead of waiting for an email link.</p>
      <form class="row" onSubmit={async (e) => {
        e.preventDefault();
        const form = e.currentTarget as HTMLFormElement;
        const f = new FormData(form);
        const pw = String(f.get("pw")), pw2 = String(f.get("pw2"));
        if (pw.length < 12) return setMsg({ ok: false, text: "Use at least 12 characters." });
        if (pw !== pw2) return setMsg({ ok: false, text: "The two passwords don't match." });
        setBusy(true);
        const { error } = await sb().auth.updateUser({ password: pw });
        setBusy(false);
        if (error) return setMsg({ ok: false, text: error.message });
        form.reset();
        setMsg({ ok: true, text: "Password saved. You can now sign in with it." });
      }}>
        <input name="pw" type="password" placeholder="New password (12+ characters)" autoComplete="new-password" required minLength={12} />
        <input name="pw2" type="password" placeholder="Repeat password" autoComplete="new-password" required minLength={12} />
        <button disabled={busy}>Save password</button>
      </form>
      {msg && <p class={msg.ok ? "small" : "error small"}>{msg.text}</p>}
    </section>
  );
}

/** Theme, accent color and density for this device. */
export function AppearanceCard() {
  const [p, setP] = useState(prefs());
  const set = (k: "theme" | "accent" | "density", v: string) => { setPref(k, v); setP(prefs()); };
  const ACCENTS: Array<[Accent, string]> = [["blue", "#2456c7"], ["teal", "#0f766e"], ["purple", "#6d28d9"], ["rose", "#be123c"], ["amber", "#b45309"]];
  return (
    <section class="card">
      <header><h2>Appearance</h2></header>
      <div class="grid2">
        <div><p class="small muted">Theme</p>
          <div class="seg" role="group" aria-label="Theme">
            {(["system", "light", "dark"] as const).map((t) => <button type="button" aria-pressed={p.theme === t} onClick={() => set("theme", t)}>{t[0]!.toUpperCase() + t.slice(1)}</button>)}
          </div></div>
        <div><p class="small muted">Density</p>
          <div class="seg" role="group" aria-label="Density">
            {(["comfortable", "compact"] as const).map((d) => <button type="button" aria-pressed={p.density === d} onClick={() => set("density", d)}>{d[0]!.toUpperCase() + d.slice(1)}</button>)}
          </div></div>
        <div class="span2"><p class="small muted">Accent color</p>
          <div class="swatches">{ACCENTS.map(([a, c]) => (
            <button type="button" class="swatch" style={{ background: c }} aria-label={a} aria-pressed={p.accent === a} onClick={() => set("accent", a)} />
          ))}</div></div>
      </div>
      <p class="small muted">Saved on this device. “System” follows your phone or computer's light/dark setting.</p>
    </section>
  );
}
